import {ChildDataLocation} from "common/flowmaster/types/data_location";
import {WorkflowInput, WorkflowInputId} from "common/flowmaster/types/workflow";

export interface MappedInputValues {
  inputValues: Record<WorkflowInputId, ChildDataLocation<string>>;
  copiedCount: number;
  emptyInputs: WorkflowInput[];
  droppedInputs: WorkflowInput[];
}

export default function mapInputValuesByName(
  oldInputs: WorkflowInput[],
  newInputs: WorkflowInput[],
  oldValues: Record<WorkflowInputId, ChildDataLocation<string>>,
): MappedInputValues {
  const inputValues: Record<WorkflowInputId, ChildDataLocation<string>> = {};
  const matchedOldIds = new Set<WorkflowInputId>();
  const emptyInputs: WorkflowInput[] = [];

  for (const newInput of newInputs) {
    const oldInput = oldInputs.find(
      input =>
        input.name === newInput.name &&
        input.type === newInput.type &&
        oldValues[input.id] !== undefined &&
        !matchedOldIds.has(input.id),
    );
    if (oldInput) {
      inputValues[newInput.id] = oldValues[oldInput.id];
      matchedOldIds.add(oldInput.id);
    } else {
      emptyInputs.push(newInput);
    }
  }

  const droppedInputs = oldInputs.filter(
    input => oldValues[input.id] !== undefined && !matchedOldIds.has(input.id),
  );

  return {
    inputValues,
    copiedCount: matchedOldIds.size,
    emptyInputs,
    droppedInputs,
  };
}
